"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Input = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRedux = require("react-redux");

var _reactIntl = require("react-intl");

var _constants = require("../constants");

var _app = require("../store/actions/app");

var _conversation = require("../store/actions/conversation");

var _traffic = require("../store/actions/traffic");

var _images = require("../images/");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var maxInputLength = 500;

var Input =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Input, _PureComponent);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Input).call(this, props));
    _this.inputElementRef = _react["default"].createRef();
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onKeyPress = _this.onKeyPress.bind(_assertThisInitialized(_this));
    _this.submit = _this.submit.bind(_assertThisInitialized(_this));
    _this.updateHeight = _this.updateHeight.bind(_assertThisInitialized(_this));
    _this.placeholderText = _this.placeholderText.bind(_assertThisInitialized(_this));
    _this.state = {
      utterance: ''
    };
    return _this;
  }

  _createClass(Input, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.state.utterance === '') {
        this.updateHeight();
      }
    }
  }, {
    key: "getInputElementNode",
    value: function getInputElementNode() {
      return this.inputElementRef.current;
    }
  }, {
    key: "onChange",
    value: function onChange(event) {
      var appBlocked = this.props.appBlocked;
      if (appBlocked) return;
      var value = event.target.value;
      var utteranceNew = value.replace(/(<([^>]+)>)/ig, '');
      this.setState({
        utterance: utteranceNew
      });
      this.updateHeight();

      if (value.length) {
        this.props.appTypingUserPing();
      }
    }
  }, {
    key: "onKeyPress",
    value: function onKeyPress(event) {
      if (event && event.key === 'Enter') {
        event.preventDefault();
        this.submit();
      }
    }
  }, {
    key: "submit",
    value: function submit() {
      var utterance = this.state.utterance;

      if (utterance.length && !this.props.appBlocked) {
        this.props.appScrolledSet(true);
        this.props.conversationAppend({
          items: [utterance],
          type: _constants.CONVERSATION_TYPE_UTTERANCE
        });
        this.props.conversationSend(utterance);
        this.setState({
          utterance: ''
        });
        this.props.trafficUtteranceSubmit({
          utterance: utterance
        });
        this.props.trafficSurveyQuestionAnswered(utterance);
      }
    }
  }, {
    key: "updateHeight",
    value: function updateHeight() {
      var inputElementNode = this.getInputElementNode();
      inputElementNode.style.height = 'auto';
      inputElementNode.style.height = "".concat(inputElementNode.scrollHeight, "px");
    }
  }, {
    key: "placeholderText",
    value: function placeholderText() {
      if (this.props.appBlocked) {
        return this.props.intl.formatMessage({
          id: 'Support:HelpBot:Input:Wait'
        });
      }

      if (this.props.appInputValidation && this.props.appInputValidation.inputPlaceholderText) {
        return this.props.appInputValidation.inputPlaceholderText;
      }

      return this.props.intl.formatMessage({
        id: 'Support:HelpBot:Input:Message'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var appBlocked = this.props.appBlocked;
      return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
        className: "jsx-2707678842" + " " + 'chatbot-input-container'
      }, _react["default"].createElement("textarea", {
        ref: this.inputElementRef,
        placeholder: this.placeholderText(),
        rows: 1,
        value: this.state.utterance,
        onChange: this.onChange,
        onKeyPress: this.onKeyPress,
        maxLength: maxInputLength,
        className: "jsx-2707678842" + " " + ((0, _classnames["default"])('chatbot-input', appBlocked ? 'chatbot-input-blocked' : null) || "")
      }), _react["default"].createElement("span", {
        onClick: this.submit,
        onKeyPress: this.onKeyPress,
        role: "button",
        tabIndex: "0",
        title: "Submit",
        className: "jsx-2707678842" + " " + 'chatbot-input-submit'
      }, _react["default"].createElement("img", {
        src: _images.iconArrowRight,
        alt: "Submit Button Arrow Icon",
        className: "jsx-2707678842"
      }))), _react["default"].createElement(_style["default"], {
        id: "2707678842"
      }, ".chatbot-input-container.jsx-2707678842{border-top:1px solid #c1c1c1;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;position:relative;}.chatbot-input-container.jsx-2707678842 .chatbot-input.jsx-2707678842{border:0;border-radius:0;box-sizing:border-box;color:#444;-webkit-flex:1;-ms-flex:1;flex:1;font-size:16px;line-height:1.25;max-height:120px;min-height:67px;outline:none;padding-left:18px;padding-right:4px;padding-top:23px;padding-bottom:23px;resize:none;}.chatbot-input-container.jsx-2707678842 .chatbot-input.chatbot-input-blocked.jsx-2707678842{cursor:wait;}.chatbot-input-container.jsx-2707678842 .chatbot-input.jsx-2707678842::-webkit-input-placeholder{color:#c1c1c1;}.chatbot-input-container.jsx-2707678842 .chatbot-input-submit.jsx-2707678842{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff;cursor:pointer;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;outline:none;width:67px;}.chatbot-input-container.jsx-2707678842 .chatbot-input-submit.jsx-2707678842:active{background-color:#f7f7f7;}.chatbot-input-container.jsx-2707678842 .chatbot-input-submit.jsx-2707678842:focus{outline:#f0e3f4 solid medium;outline-offset:-3px;}.chatbot-input-container.jsx-2707678842 .chatbot-input-submit.jsx-2707678842 img.jsx-2707678842{width:20px;}.chatbot-input-container.jsx-2707678842 .chatbot-input-cover.jsx-2707678842{-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#fff;color:#444;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;font-size:15px;height:100%;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;left:0;position:absolute;top:0;width:100%;z-index:1;}.chatbot-input-container.jsx-2707678842 .chatbot-input-cover.jsx-2707678842 .chatbot-input-cover-loading.jsx-2707678842{padding-bottom:4px;padding-top:10px;}"));
    }
  }]);

  return Input;
}(_react.PureComponent);

exports.Input = Input;
Input.propTypes = {
  appBlocked: _propTypes["default"].bool.isRequired,
  appScrolledSet: _propTypes["default"].func.isRequired,
  appTypingUserPing: _propTypes["default"].func.isRequired,
  appInputValidation: _propTypes["default"].object,
  intl: _reactIntl.intlShape,
  conversationSend: _propTypes["default"].func.isRequired,
  conversationAppend: _propTypes["default"].func.isRequired,
  trafficSurveyQuestionAnswered: _propTypes["default"].func.isRequired,
  trafficUtteranceSubmit: _propTypes["default"].func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    appBlocked: state.app.blocked,
    appInputValidation: state.app.inputValidation
  };
};

var mapDispatchToProps = {
  appScrolledSet: _app.appScrolledSet,
  appTypingUserPing: _app.appTypingUserPing,
  conversationSend: _conversation.conversationSend,
  conversationAppend: _conversation.conversationAppend,
  trafficSurveyQuestionAnswered: _traffic.trafficSurveyQuestionAnswered,
  trafficUtteranceSubmit: _traffic.trafficUtteranceSubmit
};

var _default = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Input));

exports["default"] = _default;